import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, Globe2, HeartHandshake, Sparkles, ArrowUpRight, Check } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const CREAM = '#F6EFE6';
const BURGUNDY = '#4A1721';
const ROSE_SOFT = '#F7D5DA';

const BENEFITS = [
  'Early access to retreats & member-only events',
  'Guided meditations, Osho talks & the Sangha feed',
  'Discounts on programs and the eco-store',
];
const STATS = [
  { icon: Users, number: '12,000+', label: 'Seekers worldwide' },
  { icon: Globe2, number: '40+', label: 'Countries reached' },
  { icon: HeartHandshake, number: '1,000+', label: 'Meditations & retreats held' },
];

const CommunityJoin = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSending(true);
    setTimeout(() => {
      toast({ title: 'Welcome to the Sangha 🌸', description: "You're on the list — watch your inbox." });
      setEmail(''); setSending(false);
    }, 300);
  };

  return (
    <section id="community-join" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundColor: BURGUNDY }} data-testid="community-join">
      <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full opacity-20" style={{ background: `radial-gradient(circle,${ROSE_SOFT},transparent 70%)` }} />
      <div className="relative max-w-[1300px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(246,239,230,0.15)' }}><Sparkles className="w-4 h-4" style={{ color: ROSE_SOFT }} /></span>
            <span className="text-xs uppercase tracking-[0.2em]" style={{ color: ROSE_SOFT }}>Sangha</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.08]" style={{ color: CREAM }}>
            Join Our Global <span className="font-italic-display" style={{ color: ROSE_SOFT }}>Community</span>
          </h2>
          <p className="mt-5 leading-relaxed max-w-xl" style={{ color: 'rgba(246,239,230,0.8)' }}>
            Become part of a worldwide circle of seekers. Share reflections, celebrate presence, and grow together on the path of awareness.
          </p>
          <ul className="mt-6 space-y-2.5">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-2.5" style={{ color: 'rgba(246,239,230,0.92)' }}>
                <Check className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: ROSE_SOFT }} /> <span>{b}</span>
              </li>
            ))}
          </ul>
          <form onSubmit={submit} className="mt-8 flex flex-wrap gap-3 max-w-lg" data-testid="community-join-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address" data-testid="community-join-email"
              className="flex-1 min-w-[220px] rounded-full px-5 py-3 focus:outline-none" style={{ backgroundColor: 'rgba(246,239,230,0.96)', color: BURGUNDY }} />
            <button type="submit" disabled={sending} data-testid="community-join-submit"
              className="rounded-full font-medium px-6 py-3 transition-opacity hover:opacity-90 inline-flex items-center gap-2 disabled:opacity-60" style={{ backgroundColor: ROSE_SOFT, color: BURGUNDY }}>
              Join us <ArrowUpRight className="w-4 h-4" />
            </button>
          </form>
          <Link to="/community" className="inline-block mt-4 underline underline-offset-4 hover:opacity-80 transition-opacity" style={{ color: ROSE_SOFT }} data-testid="community-explore-link">Explore the Sangha feed →</Link>
        </div>

        <div className="grid sm:grid-cols-3 lg:grid-cols-1 gap-4">
          {STATS.map((s) => (
            <div key={s.label} className="rounded-3xl p-6 backdrop-blur-sm" style={{ backgroundColor: 'rgba(246,239,230,0.10)', border: '1px solid rgba(246,239,230,0.15)' }}>
              <s.icon className="w-6 h-6 mb-3" style={{ color: ROSE_SOFT }} />
              <div className="font-serif-display text-4xl leading-none" style={{ color: CREAM }}>{s.number}</div>
              <div className="mt-2 text-sm" style={{ color: 'rgba(246,239,230,0.7)' }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommunityJoin;
